// ── SinceLastVisitPill ✦ — observational, 2nd+ visit only ───────
//
// Composes a single calm, observational line from raw counts. The
// backend only enables this payload on a 2nd+ dashboard view, so
// a first arrival never feels measured. Priority:
//   specific single signal → calm specific sentence
//   multiple signals       → warm fallback
//
// BANNED here (constitutional, locked 2026-05-20):
//   • timestamps, "last viewed", "X days ago"
//   • activity-monitoring framing
//   • engagement language
import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
import { TEXT, SAGE } from './palette';

export const composeSinceLine = (since) => {
  if (!since || !since.enabled) return '';
  const o = since.new_opportunities || 0;
  const e = since.new_completed_events || 0;
  const r = since.new_references || 0;
  const signals = [o > 0, e > 0, r > 0].filter(Boolean).length;
  if (signals === 0) return '';
  if (signals > 1) return 'Their EventDrop journey has grown since your last visit ✦';
  if (o > 0) return o === 1
    ? '1 new opportunity has been lined up ✦'
    : `${o} new opportunities have been lined up ✦`;
  if (e > 0) return e === 1
    ? 'A new event has been completed since your last visit ✦'
    : `${e} more events have been completed since your last visit ✦`;
  if (r > 0) return r === 1
    ? 'A new trust moment was added since your last visit ✦'
    : `${r} new trust moments have been added since your last visit ✦`;
  return '';
};

export const SinceLastVisitPill = ({ since }) => {
  const line = composeSinceLine(since);
  if (!line) return null;
  return (
    <div
      data-testid="parent-dashboard-since-last-visit"
      style={{
        marginTop: 18, padding: '10px 14px', borderRadius: 14,
        background: `${SAGE}10`, border: `1px solid ${SAGE}40`,
        display: 'flex', alignItems: 'center', gap: 10,
      }}
    >
      <Sparkle size={14} weight="fill" color={SAGE} />
      <p style={{ margin: 0, color: TEXT, fontSize: 13.5, lineHeight: 1.5 }}>
        {line}
      </p>
    </div>
  );
};
